import { Injectable, Output, EventEmitter, Injector } from "@angular/core";
import { Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { Usuario } from "../models/usuario.model";
import { environment } from "./../../environments/environment";
import { v4 as uuidv4 } from "uuid";

const ADMIN_DEVICE_ID_KEY = "admin_device_id";

export interface RecuperaPasswordMailEnviarPayload {
  email: string;
}

export interface RecuperaPasswordMailEnviarResponse {
  status: "ok";
  hash_id: number;
}

export interface RecuperaPasswordMailConfirmarPayload {
  hash_id: number;
  hash: string;
}

export interface RecuperaPasswordMailConfirmarResponse {
  status: "ok";
}

export interface RecuperaPasswordPayload {
  hash_id: number;
  hash: string;
  password: string;
}

export interface RecuperaPasswordResponse {
  status: "ok";
}

@Injectable({
  providedIn: "root",
})
export class AutentificacionService {
  url = environment.url;
  usuario: Usuario;
  mensajeOk: string;

  @Output() getLoggedInName: EventEmitter<any> = new EventEmitter();

  constructor(private http: HttpClient, private injector: Injector) {}

  login(email: string, password: string) {
    return this.http.post<any>(this.url + "back/login", {
      email,
      password,
      device_id: this.getDeviceId(),
      device_name: this.getDeviceName(),
    });
  }

  validarDispositivo(challengeId: number, code: string) {
    return this.http.post<any>(this.url + "back/validar_dispositivo", {
      challenge_id: challengeId,
      code,
      device_id: this.getDeviceId(),
      device_name: this.getDeviceName(),
    });
  }

  enviarMailRecuperacion(payload: RecuperaPasswordMailEnviarPayload) {
    return this.http.post<RecuperaPasswordMailEnviarResponse>(
      this.url + "back/recupera_password/mail/enviar",
      payload
    );
  }

  confirmarMailRecuperacion(payload: RecuperaPasswordMailConfirmarPayload) {
    return this.http.post<RecuperaPasswordMailConfirmarResponse>(
      this.url + "back/recupera_password/mail/confirmar",
      payload
    );
  }

  recuperarPassword(payload: RecuperaPasswordPayload) {
    return this.http.put<RecuperaPasswordResponse>(
      this.url + "back/recupera_password",
      payload
    );
  }

  emitirUsuarioLogueado() {
    this.getLoggedInName.emit(this.usuario);
  }
  getUsuario() {
    return this.usuario;
  }

  getUsuarioPromise() {
    if (this.estaLogueado()) {
      const http = this.injector.get(HttpClient);
      const promise = new Promise<void>((resolve, reject) => {
        http
          .get<any>(this.url + "back/me")
          .toPromise()
          .then(
            (respuesta) => {
              if (respuesta.status == "ok") {
                this.usuario = respuesta.usuario;
                this.usuario.menues = respuesta.menues;
                this.usuario.favorite_menues = respuesta.favorite_menues || [];
                resolve();
              } else {
                this.logOut();
                resolve();
              }
            },
            (error) => {
              this.logOut();
              resolve();
            }
          );
      });
      return promise;
    }
  }
  
  logOut() {
    const route = this.injector.get(Router);
    this.http.post<any>(this.url + "back/logout", {}).subscribe();
    this.usuario = null;
    this.clearSession();
    route.navigate(["/login"]);
  }

  expulsar() {
    const route = this.injector.get(Router);
    this.usuario = null;
    this.clearSession();
    route.navigate(["/login"]);
  }

  estaLogueado() {
    return localStorage.getItem("access_token") !== null;
  }
  
  verificaErrorAutentificacion(respuesta) {
    if (respuesta.codigo && respuesta.codigo == -1) {
      this.logOut();
    }
  }

  sendEmail() {
    return this.http.post<any>(this.url + "back/mail_test", {});
  }

  private getDeviceId(): string {
    let deviceId = localStorage.getItem(ADMIN_DEVICE_ID_KEY);

    if (!deviceId) {
      deviceId = uuidv4();
      localStorage.setItem(ADMIN_DEVICE_ID_KEY, deviceId);
    }

    return deviceId;
  }

  private getDeviceName(): string {
    const platform = navigator.platform || "Dispositivo";
    const userAgent = navigator.userAgent;
    let browser = "Navegador";

    if (userAgent.includes("Edg/")) {
      browser = "Edge";
    } else if (userAgent.includes("Firefox/")) {
      browser = "Firefox";
    } else if (userAgent.includes("Chrome/")) {
      browser = "Chrome";
    } else if (userAgent.includes("Safari/")) {
      browser = "Safari";
    }

    return `${platform} - ${browser}`;
  }

  private clearSession(): void {
    const deviceId = localStorage.getItem(ADMIN_DEVICE_ID_KEY);

    localStorage.clear();
    sessionStorage.clear();

    if (deviceId) {
      localStorage.setItem(ADMIN_DEVICE_ID_KEY, deviceId);
    }
  }
}
